import './ControlPanelHome.css';

import React from 'react';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card } from 'antd';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const sections = [
  { key: 'users', title: 'User Management', icon: solid('users-gear'), link: 'users-management' },
  { key: 'organizations', title: 'Organization Management', icon: solid('building-user'), link: 'organizations-management' },
  { key: 'customization', title: 'User Interface Customization', icon: solid('sliders'), link: 'ui-customization' },
]

export default function ControlPanelHome() {
  return (
    <Container className="py-4 px-5 my-3" fluid>
      <h5 className="mb-4">
        <FontAwesomeIcon icon={solid('server')} />
        <span className="ms-3">Control Panel</span>
      </h5>

      <Row>
        {sections.map(section => (
          <Col key={section.key} sm={6} md={4} lg={3}>
            <Link to={section.link}>
              <Card className="control-panel-card">
                <FontAwesomeIcon icon={section.icon} size="2x" />
                <h6 className="mt-3">{section.title}</h6>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </Container>
  )
}
